import { defineMessages } from 'react-intl';

export const tabbedHeroSectionPagesMessages = defineMessages({
	tabName: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.tabName',
		defaultMessage: 'Pages',
	},
	contentTitle: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.title.v2',
		defaultMessage: 'Get everyone on the same page',
	},
	contentDescription: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.description.v2',
		defaultMessage:
			'Take notes, plan projects, and refine ideas with flexible Confluence live docs and pages. Or let AI do it for you.',
	},
	contentIconTitle: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.iconsHeader',
		defaultMessage: 'Create content with ease:',
	},
	contentFeaturePoint1: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon1',
		defaultMessage: 'Countless templates to get started fast',
	},
	contentFeaturePoint2: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon2',
		defaultMessage: 'Realtime collaboration with live docs, or draft and publish with pages',
	},
	contentFeaturePoint3: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon3',
		defaultMessage: 'AI editor to fill in the blanks',
	},
	contentCta: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Pages.cta',
		defaultMessage: 'Try it out',
	},
});

export const tabbedHeroSectionWhiteboardsMessages = defineMessages({
	tabName: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.tabName',
		defaultMessage: 'Whiteboards',
	},
	contentTitle: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.title',
		defaultMessage: 'Next-gen brainstorming',
	},
	contentDescription: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.description',
		defaultMessage:
			'Capture free-flowing thoughts and collaborate on ideas with Confluence Whiteboards.',
	},
	contentIconTitle: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.iconsHeader',
		defaultMessage: 'Ideate on an infinite canvas with:',
	},
	contentFeaturePoint1: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon1',
		defaultMessage: 'Brainstorming templates',
	},
	contentFeaturePoint2: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon2',
		defaultMessage: 'Diagrams and flow charts',
	},
	contentFeaturePoint3: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon3',
		defaultMessage: 'Team retrospectives',
	},
	contentCta: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.cta',
		defaultMessage: 'Explore Whiteboards',
	},
});

export const tabbedHeroSectionDatabasesMessages = defineMessages({
	tabName: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabName',
		defaultMessage: 'Databases',
	},
	tabLozenge: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabLozenge',
		defaultMessage: 'beta',
	},
	contentTitle: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.title',
		defaultMessage: 'A new way to stay in sync',
	},
	contentDescription: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.description',
		defaultMessage:
			'Add structure, sync in real-time, and visualize your team’s work with Confluence Databases.',
	},
	contentIconTitle: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.iconsHeader',
		defaultMessage: 'Connect and relate information with:',
	},
	contentFeaturePoint1: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon1',
		defaultMessage: 'Dynamic fields',
	},
	contentFeaturePoint2: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon2',
		defaultMessage: 'Configurable views',
	},
	contentFeaturePoint3: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon3',
		defaultMessage: 'Aggregated data sources',
	},
	contentCta: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Databases.cta',
		defaultMessage: 'Explore Databases',
	},
});

export const tabbedHeroSectionSpacesMessages = defineMessages({
	tabName: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.tabName',
		defaultMessage: 'Spaces',
	},
	contentTitle: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.title',
		defaultMessage: 'Find what you need',
	},
	contentDescription: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.description',
		defaultMessage:
			'Organize knowledge across teams, projects, and goals with Spaces in Confluence.',
	},
	contentIconTitle: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.iconsHeader',
		defaultMessage: 'Discover relevant information with:',
	},
	contentFeaturePoint1: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon1',
		defaultMessage: 'Structured page tree',
	},
	contentFeaturePoint2: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon2',
		defaultMessage: 'Centralized access to knowledge',
	},
	contentFeaturePoint3: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon3',
		defaultMessage: 'Customizable permissions',
	},
	contentCta: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Spaces.cta',
		defaultMessage: 'Explore knowledge sharing',
	},
});
